(function() { window.GUID_1e5041cd_26a6_4d49_b78c_cc4ff6c03ecd = { getGuid: function() { return "1e5041cd-26a6-4d49-b78c-cc4ff6c03ecd"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class FrozenCsrAlert extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.controlId}`);
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.eventId = params[1] ? params[1].toString() : "";
                this.context = params[2] ? params[2].toString() : "";
                this.isDismissable = params[3] == "true" || params[3] === true;
                this.dbName = params[4] ? params[4].toString() : FrozenCsrAlert.defaultDbName;
            }
            OnBindEvents() {
                this.$Control.offon("click.frozen-csr-alert-learn-more", this.handleLearnMoreClick.bind(this));
                if (this.isDismissable) {
                    this.$Control.offon("click.frozen-csr-alert-dismiss", ".frozen-csr-alert__close", this.handleDismissClick.bind(this));
                }
                this.syncDismissedState();
            }
            handleLearnMoreClick(e) {
                const url = CS.Url.CSUrl("FrozenCSRExplanationModal");
                if (url) {
                    Controls.Popup.ShowAjaxModal(url, {}, () => { }, () => { }, true);
                }
            }
            syncDismissedState() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (!this.isDismissable) {
                        this.$Control.removeClass(FrozenCsrAlert.dismissedClass);
                        return;
                    }
                    const dismissed = yield this.isDismissedAsync();
                    if (dismissed) {
                        this.$Control.addClass(FrozenCsrAlert.dismissedClass);
                    }
                    else {
                        this.$Control.removeClass(FrozenCsrAlert.dismissedClass);
                    }
                });
            }
            get dismissNamespace() {
                const eventId = (this.eventId || "").toString().trim();
                return `eventId:${eventId}`;
            }
            get dismissKey() {
                const context = (this.context || "").toString().trim();
                return context || "default";
            }
            getDismissStore() {
                return CS.IDB.createKV({
                    dbName: this.dbName,
                }).withNamespace(this.dismissNamespace);
            }
            isDismissedAsync() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        return yield this.getDismissStore().has(this.dismissKey);
                    }
                    catch (error) {
                        console.error("Error while reading frozen CSR dismissed state.", error);
                        return false;
                    }
                });
            }
            handleDismissClick(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                this.dismissAsync();
            }
            dismissAsync() {
                return __awaiter(this, void 0, void 0, function* () {
                    this.$Control.slideUp(300, () => {
                        this.$Control.addClass(FrozenCsrAlert.dismissedClass);
                    });
                    try {
                        yield this.getDismissStore().set(this.dismissKey, {
                            dismissed: true,
                            dismissedAtUtc: new Date().toISOString(),
                        }, {
                            ttl: 7 * 24 * 60 * 60 * 1000,
                        });
                    }
                    catch (error) {
                        console.error("Error while persisting frozen CSR dismissed state.", error);
                    }
                });
            }
            OnDispose() { }
        }
        FrozenCsrAlert.dismissedClass = "dismissed";
        FrozenCsrAlert.defaultDbName = "FrozenCsrAlertDismissedState";
        Controls.FrozenCsrAlert = FrozenCsrAlert;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=frozen-csr-alert.js.map
